import { httpPUT } from './utils.js';
import { ACTIONS } from '../const';
import { getPreferences } from '../selectors/current_user';
import { STORAGE_KEY, uninstallSW, swEnabled } from '../engage_cache.js';

export const updatePreferences = (user, data) => (dispatch, getState) => {
    const preferencesUrl = user.preferences;
    const prefs = {
        ...getPreferences(getState()),
        ...data,
    };

    dispatch({
        type: ACTIONS.MERGE_PREFERENCES,
        payload: data,
    });
    httpPUT(preferencesUrl, prefs);
};

// This doesn't need `dispatch`, but I'm using a thunk so it has the same
// behavior as normal actions. Nothing happens until this action is dispatched.
export const logout = () => dispatch => {
    if (swEnabled) {
        uninstallSW();
        if ('localStorage' in global) {
            localStorage.removeItem(STORAGE_KEY);
        }
    }
    window.location = '/api/v3/user/logout';
};



// WEBPACK FOOTER //
// ./src/actions/user.js